module.exports = __webpack_public_path__ + "media/images/profile-5ec1492a221512a044b4407a442f2eab.svg";